import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.scss';
import { getServiceNotice } from './config';

const LOGO_SRC = `${process.env.PUBLIC_URL}/main_logo.png`;

const DEFAULT_MESSAGE =
    'Ο πάροχος φιλοξενίας μας αντιμετωπίζει προσωρινό τεχνικό πρόβλημα και η υπηρεσία ενδέχεται να μην ανταποκρίνεται. Εργαζόμαστε για την αποκατάσταση.';

function ServiceUnavailablePage() {
    return (
        <div id="root">
            <main className="main-container under-construction-page">
                <Container className="custom-container under-construction-container py-4 px-3 px-md-4">
                    <div className="under-construction text-center">
                        <img
                            src={LOGO_SRC}
                            alt="teachers-app.com"
                            className="app-logo-img under-construction-logo"
                        />
                        <h2 className="mb-3">Προσωρινά μη διαθέσιμο</h2>
                        <p className="mb-3">
                            {getServiceNotice() || DEFAULT_MESSAGE}
                        </p>

                        <p className="text-muted mb-0 mt-3 under-construction-contact">
                            Επικοινωνία:{' '}
                            <a href="mailto:support@teachers-app.com" className="text-decoration-none under-construction-email">
                                <strong>support@teachers-app.com</strong>
                            </a>
                        </p>
                    </div>
                </Container>
            </main>
        </div>
    );
}

export default ServiceUnavailablePage;
